export const RefreshIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.364 18.364C16.7353 19.9927 14.4853 21 12 21C7.02945 21 3 16.9706 3 12C3 7.02945 7.02945 3 12 3C14.4853 3 16.7353 4.00736 18.364 5.63605C18.8865 6.15863 19.7978 7.16043 20.4 7.82961"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
    <path d="M21 4V8.5H16.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" strokeWidth="1.8" />
  </svg>
);
